import { useMutation } from '@tanstack/react-query';
import api from '../../api';
import { type ApiErrorResponse, type ApiResponse } from '../../types';
import { apiPayloadMapper } from '../../utils';
import { type GenerateDTMRequestPayload } from './types';

export const generateDTMRequest = async (payload: GenerateDTMRequestPayload) =>
  await api.post<GenerateDTMRequestPayload, ApiResponse>(
    '/workspaces/generate-dtm/requests/',
    apiPayloadMapper(payload),
  );

// Hooks.
export const useGenerateDTMRequest = () =>
  useMutation<ApiResponse, ApiErrorResponse, GenerateDTMRequestPayload>({
    mutationFn: generateDTMRequest,
  });
